var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpcomingDummy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 144,
    viewBox: "0 0 157 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_189)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 144,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.205 97.9252H83.7489C82.7393 97.9252 81.9178 97.0982 81.9178 96.0819V13.2945C81.9178 12.2782 82.7393 11.4512 83.7489 11.4512H140.205C141.215 11.4512 142.036 12.2779 142.036 13.2945V96.0816C142.036 97.0982 141.215 97.9252 140.205 97.9252ZM83.7489 11.5298C82.7821 11.5298 81.9959 12.3216 81.9959 13.2945V96.0816C81.9959 97.0548 82.7824 97.8463 83.7489 97.8463H140.205C141.172 97.8463 141.958 97.0545 141.958 96.0816V13.2945C141.958 12.3216 141.172 11.5298 140.205 11.5298H83.7489Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1037 97.9252H18.6473C17.6378 97.9252 16.8163 97.0982 16.8163 96.0819V13.2945C16.8163 12.2782 17.6375 11.4512 18.6473 11.4512H75.1037C76.1132 11.4512 76.9347 12.2779 76.9347 13.2945V96.0816C76.935 97.0982 76.1135 97.9252 75.1037 97.9252ZM18.6473 11.5298C17.6809 11.5298 16.8944 12.3216 16.8944 13.2945V96.0816C16.8944 97.0548 17.6809 97.8463 18.6473 97.8463H75.1037C76.0704 97.8463 76.8566 97.0545 76.8566 96.0816V13.2945C76.8566 12.3216 76.0701 11.5298 75.1037 11.5298H18.6473Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.723 117.129H1.54688V117.207H157.723V117.129Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9059 19.4364H67.7672C68.0258 19.4364 68.2357 19.2251 68.2357 18.9647V16.7236C68.2357 16.4633 68.0258 16.252 67.7672 16.252H57.9059C57.647 16.252 57.4374 16.4633 57.4374 16.7236V18.9647C57.4374 19.2251 57.647 19.4364 57.9059 19.4364Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0154 23.499H61.8767C62.1353 23.499 62.3452 23.2877 62.3452 23.0274V20.7862C62.3452 20.5259 62.1353 20.3146 61.8767 20.3146H52.0154C51.7568 20.3146 51.5469 20.5259 51.5469 20.7862V23.0274C51.5469 23.288 51.7568 23.499 52.0154 23.499Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5886 67.203H21.7273C21.4687 67.203 21.2588 66.9917 21.2588 66.7313V64.4902C21.2588 64.2299 21.4687 64.0186 21.7273 64.0186H31.5886C31.8472 64.0186 32.0571 64.2299 32.0571 64.4902V66.7313C32.0571 66.992 31.8472 67.203 31.5886 67.203Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4782 71.2636H27.617C27.3583 71.2636 27.1484 71.0523 27.1484 70.7919V68.5508C27.1484 68.2904 27.3583 68.0791 27.617 68.0791H37.4782C37.7369 68.0791 37.9468 68.2904 37.9468 68.5508V70.7919C37.9468 71.0526 37.7369 71.2636 37.4782 71.2636Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.625 70.413H116.763C116.505 70.413 116.295 70.2017 116.295 69.9413V67.7002C116.295 67.4395 116.505 67.2285 116.763 67.2285H126.625C126.883 67.2285 127.093 67.4395 127.093 67.7002V69.9413C127.093 70.2017 126.884 70.413 126.625 70.413Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.406 70.413H128.545C128.286 70.413 128.076 70.2017 128.076 69.9413V67.7002C128.076 67.4395 128.286 67.2285 128.545 67.2285H138.406C138.665 67.2285 138.874 67.4395 138.874 67.7002V69.9413C138.874 70.2017 138.665 70.413 138.406 70.413Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.514 74.4743H122.652C122.394 74.4743 122.184 74.263 122.184 74.0026V71.7615C122.184 71.5011 122.394 71.2898 122.652 71.2898H132.514C132.772 71.2898 132.982 71.5011 132.982 71.7615V74.0026C132.982 74.263 132.772 74.4743 132.514 74.4743Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.236 90.0968H132.97V117.128H144.236V90.0968Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.613 90.0968H108.762V117.128H135.613V90.0968Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.217 90.0968H120.9V117.05H124.217V90.0968Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7231 90.0955H40.4572V117.127H51.7231V90.0955Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0992 90.0955H16.2482V117.127H43.0992V90.0955Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7035 90.0955H28.386V117.049H31.7035V90.0955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.763 104.476H97.4969V117.129H108.763V104.476Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.14 104.476H73.2891V117.129H100.14V104.476Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7444 104.476H85.4269V117.092H88.7444V104.476Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9905 77.4445H45.7246V90.0977H56.9905V77.4445Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3667 77.4445H21.5156V90.0977H48.3667V77.4445Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9709 77.4445H33.6534V90.061H36.9709V77.4445Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.482 17.5098H87.7998V42.3582H112.482V17.5098Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.233 41.1014V18.7686L89.0493 18.7686V41.1014H111.233Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6545 36.0291C98.6545 36.0291 102.728 27.6216 111.233 27.453V41.1009H100.141L98.6545 36.0291Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0498 33.6683C89.0498 33.6683 92.7128 31.735 96.4357 33.1542C101.111 34.9362 103.822 41.1007 103.822 41.1007H89.0498V33.6683Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6596 29.7872C98.8211 29.7872 100.573 28.0232 100.573 25.8471C100.573 23.6711 98.8211 21.907 96.6596 21.907C94.4981 21.907 92.7458 23.6711 92.7458 25.8471C92.7458 28.0232 94.4981 29.7872 96.6596 29.7872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2462 17.5098H20.5918V59.7138H42.2462V17.5098Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9969 58.4569L40.9969 18.7685L21.8413 18.7685L21.8413 58.4569H40.9969Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4743 35.0052C30.6358 35.0052 32.3881 33.2412 32.3881 31.0651C32.3881 28.889 30.6358 27.125 28.4743 27.125C26.3128 27.125 24.5605 28.889 24.5605 31.0651C24.5605 33.2412 26.3128 35.0052 28.4743 35.0052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4229 58.4557C25.4229 58.4557 30.2709 34.988 40.9974 32.8809V58.4557H31.4197H25.4229Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8417 44.5282C21.8417 44.5282 24.3096 42.1327 28.2193 43.5647C35.5664 46.2558 39.6673 58.4556 39.6673 58.4556H21.8417V44.5282Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.386 35.9272C131.97 35.4807 134.516 32.1937 134.072 28.5854C133.629 24.9771 130.364 22.414 126.78 22.8605C123.196 23.307 120.65 26.594 121.093 30.2023C121.537 33.8106 124.802 36.3737 128.386 35.9272Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.456 30.7793C134.214 27.5182 132.203 24.2558 128.963 23.4925C125.724 22.7292 122.484 24.7541 121.725 28.0152C120.967 31.2763 122.979 34.5387 126.218 35.302C129.457 36.0652 132.698 34.0404 133.456 30.7793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.601 23.8818H127.375V25.1466H127.601V23.8818Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.602 33.6152H127.377V34.88H127.602V33.6152Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.279 29.2676H122.022V29.4946H123.279V29.2676Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.945 29.2676H131.689V29.4946H132.945V29.2676Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.271 25.4183L130.383 26.3125L130.542 26.4731L131.431 25.5789L131.271 25.4183Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.433 32.2891L123.545 33.1837L123.704 33.3442L124.592 32.4495L124.433 32.2891Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.712 25.4156L123.553 25.5762L124.441 26.4703L124.601 26.3098L123.712 25.4156Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.543 32.2967L130.384 32.4572L131.272 33.3516L131.431 33.1911L130.543 32.2967Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.452 29.2281L127.381 29.4092L129.511 30.2536L129.582 30.0725L127.452 29.2281Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.582 29.4792H124.068V29.2846H127.388V26.5391H127.582V29.4792Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.628 130.899C147.628 131.999 117.457 132.891 80.241 132.891C43.0246 132.891 12.8545 131.999 12.8545 130.899C12.8545 129.799 43.0246 128.907 80.241 128.907C117.457 128.907 147.628 129.799 147.628 130.899Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4024 53.54L104.328 58.8908H78.6193L73.5957 53.54H98.4024Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M98.4024 53.54L104.328 58.8908H78.6193L73.5957 53.54H98.4024Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4127 53.54H73.5945V78.5252H98.4127V53.54Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M98.4127 53.54H73.5945V78.5252H98.4127V53.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4403 53.54H65.6221V78.5252H90.4403V53.54Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6346 53.54L59.709 58.8908H85.4178L90.4413 53.54H65.6346Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M65.6346 53.54L59.709 58.8908H85.4178L90.4413 53.54H65.6346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4376 62.1494C80.7512 62.1494 82.3223 63.5226 82.3223 65.782C82.3223 68.2325 80.5959 69.3105 78.2823 69.3105L78.2136 70.6837H76.5041L76.4179 67.9545H76.9876C78.9389 67.9545 80.441 67.6071 80.441 65.782C80.441 64.5654 79.6985 63.8179 78.4554 63.8179C77.2297 63.8179 76.4529 64.5128 76.4529 65.7298H74.6056C74.5872 63.627 76.0896 62.1494 78.4376 62.1494ZM77.3325 74.525C76.6244 74.525 76.0721 73.9688 76.0721 73.2565C76.0721 72.5437 76.6247 71.9877 77.3325 71.9877C78.0231 71.9877 78.5756 72.544 78.5756 73.2565C78.5759 73.9688 78.0234 74.525 77.3325 74.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5166 78.5283H62.2607V81.1169H91.5166V78.5283Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M91.5166 78.5283H62.2607V81.1169H91.5166V78.5283Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.384 78.5283H91.5178V81.1169H102.384V78.5283Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M102.384 78.5283H91.5178V81.1169H102.384V78.5283Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6236 81.1172H79.8604V129.823H81.6236V81.1172Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M81.6236 81.1172H79.8604V129.823H81.6236V81.1172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M81.6236 82.3294L79.8604 83.0633V81.1172H81.6236V82.3294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3614 131.399H72.1211V131.39C72.1211 129.978 73.2584 128.833 74.6608 128.833H86.8213C88.2241 128.833 89.3611 129.978 89.3611 131.39V131.399H89.3614Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4521 105.432C28.4521 105.432 30.5843 104.649 31.1362 106.922C31.6881 109.195 33.268 108.608 33.5669 108.11C34.1563 107.129 34.2388 103.578 33.2252 103.364C32.0148 103.108 28.8788 104.397 28.4521 105.432Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4521 105.432C28.4521 105.432 30.5843 104.649 31.1362 106.922C31.6881 109.195 33.268 108.608 33.5669 108.11C34.1563 107.129 34.2388 103.578 33.2252 103.364C32.0148 103.108 28.8788 104.397 28.4521 105.432Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.2235 103.365C30.7228 103.402 30.0612 105.613 29.6595 107.561L28.8468 106.034L29.4231 108.745C29.3613 109.041 29.2966 109.314 29.2223 109.552C28.6204 111.472 26.7637 112.057 26.7637 112.057C26.7637 112.057 26.6516 111.277 26.5529 110.182V110.181L27.4628 108.74L26.4739 109.159C26.3633 107.441 26.3483 105.376 26.7637 104.198C27.5668 101.926 29.7211 102.625 29.7211 102.625L33.2235 103.365Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4559 100.982C39.4559 100.982 38.1453 100.585 36.7719 102.472C35.4484 104.291 34.9209 104.504 34.0238 103.797C33.1267 103.09 33.6693 99.1279 34.6825 98.9138C35.8932 98.6581 39.0295 99.9468 39.4559 100.982Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4559 100.982C39.4559 100.982 38.1453 100.585 36.7719 102.472C35.4484 104.291 34.9209 104.504 34.0238 103.797C33.1267 103.09 33.6693 99.1279 34.6825 98.9138C35.8932 98.6581 39.0295 99.9468 39.4559 100.982Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.6697 111.307C43.6697 111.307 42.0389 110.793 40.9213 109.248L42.3668 105.832L40.3847 108.32C40.3013 108.134 40.226 107.939 40.161 107.732C39.3017 104.992 39.4776 99.0452 34.5371 98.9732L39.4488 97.8452C39.4488 97.8452 42.5236 96.8465 43.669 100.091C43.9611 100.916 44.1041 102.048 44.1554 103.276L42.3665 101.609C42.3665 101.609 43.6069 103.421 44.1772 104.177C44.2063 107.574 43.6697 111.307 43.6697 111.307Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9551 95.7147C26.9551 95.7147 29.0872 94.9317 29.6391 97.2046C30.191 99.4774 32.9675 100.345 33.2524 99.2344C33.5563 98.0492 32.8845 93.8273 31.8712 93.6132C30.6605 93.3576 27.3814 94.6792 26.9551 95.7147Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9551 95.7147C26.9551 95.7147 29.0872 94.9317 29.6391 97.2046C30.191 99.4774 32.9675 100.345 33.2524 99.2344C33.5563 98.0492 32.8845 93.8273 31.8712 93.6132C30.6605 93.3576 27.3814 94.6792 26.9551 95.7147Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.9596 93.6264C27.9205 93.6855 27.2434 97.7174 26.6608 100.684L24.6027 97.6954C24.629 97.7819 25.7203 101.348 26.1423 102.762C25.1909 105.259 22.7399 106.032 22.7399 106.032C22.7399 106.032 22.0536 101.26 22.2741 97.597C22.876 97.0954 23.9402 96.197 23.9402 96.197L22.3629 96.5901C22.4425 95.9181 22.5646 95.3118 22.7399 94.8156C23.8853 91.5724 26.961 92.5708 26.961 92.5708L31.9596 93.6264Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5695 113.489C33.5641 113.489 33.5591 113.489 33.5535 113.488C33.4764 113.48 33.4205 113.409 33.4292 113.332C34.8279 100.801 31.3236 90.2355 31.288 90.1305C31.2627 90.0563 31.3024 89.9758 31.3758 89.9507C31.4501 89.9261 31.5298 89.9654 31.5545 90.0393C31.5904 90.1453 35.1143 100.771 33.7091 113.364C33.701 113.436 33.64 113.489 33.5695 113.489Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0026 112.578H28.1924V114.102H39.0026V112.578Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.0026 112.578H28.1924V114.102H39.0026V112.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2598 114.101H29.8824C28.9962 116.172 26.132 122.277 26.132 124.081C26.132 126.214 28.7751 130.661 28.7751 130.661C28.7751 130.981 38.3668 130.981 38.3668 130.661C38.3668 130.661 41.0099 126.214 41.0099 124.081C41.0099 122.277 38.1456 116.172 37.2598 114.101Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8219 29.1032C52.4525 29.1032 55.3957 26.1402 55.3957 22.4852C55.3957 18.8302 52.4525 15.8672 48.8219 15.8672C45.1913 15.8672 42.2482 18.8302 42.2482 22.4852C42.2482 26.1402 45.1913 29.1032 48.8219 29.1032Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8219 29.1032C52.4525 29.1032 55.3957 26.1402 55.3957 22.4852C55.3957 18.8302 52.4525 15.8672 48.8219 15.8672C45.1913 15.8672 42.2482 18.8302 42.2482 22.4852C42.2482 26.1402 45.1913 29.1032 48.8219 29.1032Z",
    fill: "#EEF7FD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.8233 29.2397C45.1238 29.2397 42.1143 26.21 42.1143 22.4856C42.1143 18.7612 45.1238 15.7314 48.8233 15.7314C52.5228 15.7314 55.5323 18.7612 55.5323 22.4856C55.5323 26.21 52.5228 29.2397 48.8233 29.2397ZM48.8233 16.0038C45.2731 16.0038 42.3848 18.9115 42.3848 22.4856C42.3848 26.0597 45.2731 28.9674 48.8233 28.9674C52.3735 28.9674 55.2618 26.0597 55.2618 22.4856C55.2618 18.9115 52.3735 16.0038 48.8233 16.0038Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8765 18.8086C50.3002 18.8086 51.2673 19.6538 51.2673 21.0444C51.2673 22.5525 50.205 23.216 48.781 23.216L48.7385 24.0612H47.6865L47.6334 22.3817H47.9838C49.1845 22.3817 50.1091 22.1679 50.1091 21.0447C50.1091 20.296 49.6521 19.8359 48.8872 19.8359C48.1328 19.8359 47.6546 20.2636 47.6546 21.0126H46.5177C46.507 19.7177 47.4316 18.8086 48.8765 18.8086ZM48.1966 26.4247C47.7608 26.4247 47.4207 26.0822 47.4207 25.6439C47.4207 25.2052 47.7608 24.8628 48.1966 24.8628C48.6217 24.8628 48.9618 25.2052 48.9618 25.6439C48.9618 26.0825 48.6217 26.4247 48.1966 26.4247Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9355 27.6483L55.0792 28.7212C55.1917 28.7775 55.3141 28.6652 55.2688 28.5473L54.3308 26.0986C53.8536 26.7813 53.3872 27.3153 52.9355 27.6483Z",
    fill: "#11274B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 144,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingDummy);
export default __webpack_public_path__ + "static/media/upcoming-dummy.4b9d41b6b22bf7ea71232da889afd9da.svg";
export { ForwardRef as ReactComponent };